<script lang="ts">
  import {Icon} from '@components';
  import FeatureFlag from '@/platform-redesign-components/FeatureFlag.svelte';
  import {each} from 'svelte/internal';
  import WrapperModal from '../modals/WrapperModal.svelte';

  export let shape: string = '';
  const shapes: string[] = ['Square', 'Horizontal', 'Vertical'];

  const removeShape = (e: any) => {
    if (e.target.value === shape) {
      shape = 'All';
    }
  };
</script>

<FeatureFlag>
  <div slot="new_component" class="flex flex-row">
    {#each shapes as choice}
      <label for={choice} class="mr-4">
        <div class="flex cursor-pointer flex-col justify-center gap-1">
          <div
            class={`icon-container  ${
              shape === choice
                ? 'bg-gray-400 text-white '
                : 'bg-gray-100 text-gray-400 hover:bg-gray-400 hover:text-white'
            }`}
          >
            <Icon name={choice} className={`w-10 h-10 `} />
          </div>
        </div>

        <input
          bind:group={shape}
          id={choice}
          type="radio"
          value={choice}
          class="hidden"
          name="filter-size"
          on:click={removeShape}
        />
        <p class="mt-2 text-center text-xs">{choice}</p>
      </label>
    {/each}
  </div>
  <div slot="current_component">
    <label for="square">
      <div class="flex cursor-pointer flex-col justify-center gap-1">
        <div class="icon-container {shape === 'Square' ? 'bg-gray-500' : 'bg-gray-400'}">
          <Icon name="Square" className="w-10 h-10 text-white" />
        </div>
      </div>

      <input
        bind:group={shape}
        id="square"
        type="radio"
        value="Square"
        class="hidden"
        name="filter-size"
        on:click={removeShape}
      />
    </label>

    <label for="vertical">
      <div class="flex cursor-pointer flex-col justify-center gap-1">
        <div class="icon-container {shape === 'Vertical' ? 'bg-gray-500' : 'bg-gray-400'}">
          <Icon name="Vertical" className="w-10 h-10 text-white" />
        </div>
      </div>

      <input
        bind:group={shape}
        id="vertical"
        type="radio"
        value="Vertical"
        class="hidden"
        name="filter-size"
        on:click={removeShape}
      />
    </label>

    <label for="horizontal">
      <div class="flex cursor-pointer flex-col justify-center gap-1">
        <div class="icon-container {shape === 'Horizontal' ? 'bg-gray-500' : 'bg-gray-400'}">
          <Icon name="Horizontal" className="w-10 h-10 text-white" />
        </div>
      </div>

      <input
        bind:group={shape}
        id="horizontal"
        type="radio"
        value="Horizontal"
        class="hidden"
        name="filter-size"
        on:click={removeShape}
      />
    </label>
  </div>
</FeatureFlag>

<style lang="postcss">
  .text-label {
    font-size: 10px;
  }

  .icon-container {
    @apply flex h-14 w-14 items-center justify-center rounded shadow transition-all;
  }
</style>
